import { useQueryParams } from 'use-query-params'

import { DashArrayParam } from '../../../../../utils/useQueryParams'
import {
    MessagesFiltersCategoriesEnum,
    MessagesFiltersEnum,
} from '../MessagesFilters'

import OtherCategory from './OtherCategory/OtherCategory'

import styles from './messages-filters-options.module.scss'

interface IMessagesFiltersOptionProps {
    category: MessagesFiltersCategoriesEnum
    filtersOptions: {
        intents: string[]
        entities: string[]
        channels: string[]
    }
}

function MessagesFiltersOptions(props: IMessagesFiltersOptionProps) {
    const { category, filtersOptions } = props

    const [query, setQuery] = useQueryParams({
        [MessagesFiltersEnum.ENTITIES]: DashArrayParam,
        [MessagesFiltersEnum.INTENTS]: DashArrayParam,
        [MessagesFiltersEnum.CHANNELS]: DashArrayParam,
    })

    const handleOptionChange = (selectedOptions: string[], option: string) => {
        const clonedSelectedOptions = structuredClone(selectedOptions) || []

        if (clonedSelectedOptions.includes(option)) {
            const index = clonedSelectedOptions.indexOf(option)
            clonedSelectedOptions.splice(index, 1)
            setQuery({
                [category]: clonedSelectedOptions.length
                    ? clonedSelectedOptions
                    : null,
            })
            return
        }

        clonedSelectedOptions?.push(option)
        setQuery({ [category]: clonedSelectedOptions })
    }

    const renderCategory = () => {
        if (category === MessagesFiltersCategoriesEnum.OTHER) {
            return <OtherCategory />
        }

        const selectedOptions = query[category] as string[]

        return filtersOptions[category].map((option) => (
            <label
                key={option}
                className={styles.messagesFiltersOptions__label}
            >
                <input
                    type="checkbox"
                    checked={selectedOptions?.includes(option)}
                    onChange={() => handleOptionChange(selectedOptions, option)}
                />
                {option}
            </label>
        ))
    }

    return (
        <div className={styles.messagesFiltersOptions}>{renderCategory()}</div>
    )
}

export default MessagesFiltersOptions
